var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 612,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 613,
	"./assets/thewest-digital-hero-variation-a.jpg": 888,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 614,
	"./assets/thewest-digital-hero-variation-b.jpg": 889,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 615,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 890,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 450,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 891,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 616,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 892,
	"./assets/thewest-digital-hero-variation-footy-lives-here-guernsey.jpg": 893,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile-guernsey.jpg": 617,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile.jpg": 451,
	"./assets/thewest-digital-hero-variation-footy-lives-here.jpg": 894,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 452,
	"./assets/thewest-digital-hero-variation-summer-of-cricket.jpg": 895,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 618,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 896,
	"./assets/thewest-digital-hero.jpg": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3003;